import marketingTracker from 'marketing-tracker';
import appConfig from 'src/utils/appConfig';

export default function() {
  const config = appConfig.serialize();
  marketingTracker.gtm.init({
    geoData: {
      city: config.geoData.city,
      countryAlpha3: config.geoData.countryCode3,
      region: config.geoData.region
    },
    learnLanguageAlpha3: config.learningLanguage,
    locale: config.locale
  });
}
